import React from 'react';
import CustomDialog from 'widgets/component/CustomDialog';
import DataTableDetailOrder from 'widgets/customDialogComponentDetails/ComponentDialog';
import UnlockIccDialog from './UnlockIccDialog';

const DialogsFailedTransactions = ({
  failedTransactionsListDetailsIpb,
  isDialogOpenDetails,
  handleOpenPopUp,
  handleClose,
  detailDialogButtons,
  isUnlockIccDialogOpen,
  handleCloseUnlockIccDialog,
  handleUnlockIcc,
  unlockIccMessage,
  isSuccessDialogOpen,
  handleCloseSuccessDialog,
  successDialogButtons,
  isDialogOpen,
  dialogMessage,
  errorDialogButtons,
  errorMessage,
}) => (
  <>
    <CustomDialog
      fullWidth
      title={'Detalle transacciones fallidas IPB'}
      content={
        Array.isArray(failedTransactionsListDetailsIpb?.response?.details) &&
        failedTransactionsListDetailsIpb?.response?.details.length > 0 ? (
          <DataTableDetailOrder
            type='DetailsFailedTransactions'
            handleOpenPopUp={handleOpenPopUp}
            response={failedTransactionsListDetailsIpb?.response}
            idTransaction={
              failedTransactionsListDetailsIpb?.response?.provider_type?.transaction_id
            }
            namePayment={failedTransactionsListDetailsIpb?.response?.provider_type?.name}
            onClose={handleClose}
          />
        ) : (
          'No hay datos'
        )
      }
      open={isDialogOpenDetails}
      onClose={handleClose}
      maxWidth='md'
      extraButtons={detailDialogButtons}
    />
    {isUnlockIccDialogOpen && (
      <UnlockIccDialog
        open={isUnlockIccDialogOpen}
        onClose={handleCloseUnlockIccDialog}
        onContinue={handleUnlockIcc}
        message={unlockIccMessage}
      />
    )}
    <CustomDialog
      open={isSuccessDialogOpen}
      onClose={handleCloseSuccessDialog}
      title='Éxito'
      content={<p>{unlockIccMessage}</p>}
      fullWidth
      maxWidth='sm'
      extraButtons={successDialogButtons}
    />
    {errorMessage !== '' ? (
      <CustomDialog
        title='Mensaje'
        content={<p>{dialogMessage}</p>}
        open={isDialogOpen}
        onClose={handleClose}
        fullWidth
        maxWidth='sm'
        extraButtons={errorDialogButtons}
      />
    ) : null}
  </>
);

export default DialogsFailedTransactions;
